import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { dollars } from "@/lib/giftIcons";

export function WalletReversals() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/wallet-reversals").then(({ data }) => setRows(data)); }, []);
  if (!rows) return <p className="text-text-muted">Loading…</p>;
  return (
    <div data-testid="wallet-reversals" className="space-y-4">
      <p className="text-sm text-text-muted">When a wallet top-up is refunded in Stripe, the same amount is taken back automatically. A negative balance means the member spent the credits first; they can't spend again until they top up.</p>
      {!rows.length ? <p data-testid="wallet-reversals-empty" className="text-text-muted text-sm">No refunds yet.</p> : rows.map((r) => (
        <div key={r.id} data-testid={`reversal-${r.id}`} className="flex flex-wrap items-center gap-3 rounded-2xl border border-white/8 bg-surface p-4 text-sm">
          <span className="min-w-0 flex-1">{r.display_name} <span className="text-text-muted break-all">· {r.email}</span></span>
          <span className="text-red-300">−{dollars(r.amount)}</span>
          <span className={r.wallet_balance < 0 ? "text-red-300" : "text-text-muted"} data-testid={`reversal-balance-${r.id}`}>
            Balance {dollars(r.wallet_balance)}{r.wallet_balance < 0 ? " · owed" : ""}
          </span>
          <span className="text-[11px] text-text-muted">{new Date(r.created_at).toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}
